var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"itemText":"org_name","itemValue":"org_guid","loading":_vm.loading,"items":_vm.organizations,"filter":_vm.filter,"label":"Organization","hide-details":"","outlined":""},model:{value:(_vm.selectedOrgGuid),callback:function ($$v) {_vm.selectedOrgGuid=$$v},expression:"selectedOrgGuid"}})
}
var staticRenderFns = []

export { render, staticRenderFns }